import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_HLkXsf2aTCZ8: {
	id: 'prd_HLkXs2DEV2f2aTCZ8'
	ident: 'prd_HLkXsf2aTCZ8'
	sku: 'simple_workbook_bundle_36_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_Ge4Em2DEV2BorZmN2'
		amount: 90
		amount_usd: 36
		currency: 'USD'
		amount_with_discount: 36
		discount: 54
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_HLkXsf2aTCZ8, OneTimeProduct>
const prd_HLkXsf2aTCZ8 = { ident: 'prd_HLkXsf2aTCZ8' } as typeof _prd_HLkXsf2aTCZ8

export default prd_HLkXsf2aTCZ8
